import { useSelector } from "react-redux";
import { selectProfile } from "../../redux/features/user/user-slice";
import { EOrgUserRole } from "../oversight-core/enums/org-user-role";
import { UserRole } from "../oversight-core/enums/user-roles";

// A monitoring guest is an outside viewer, such as a funder. The backend redacts what they
// receive and refuses the rest; these hide the parts of the dashboard that would otherwise
// show them empty or refused data.
export const isGuestRole = (role?: string) =>
  role === EOrgUserRole.ROLE_ORG_GUEST;

export const useIsGuest = () => isGuestRole(useSelector(selectProfile)?.role);

// Roles that may change a site, not only look at it. A viewer and a guest only view; the
// backend refuses their changes, so the actions are not offered to them.
const OPERATING_ROLES: string[] = [
  UserRole.ROLE_ADMIN,
  EOrgUserRole.ROLE_ORG_ADMIN,
  EOrgUserRole.ROLE_ORG_OPERATOR,
];

export const canOperateRole = (role?: string) =>
  !!role && OPERATING_ROLES.includes(role);

export const useCanOperate = () =>
  canOperateRole(useSelector(selectProfile)?.role);
